import React, { useState } from 'react';
import Cookies from 'js-cookie';

import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
  OutlinedInput,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API } from '../../config/API';
import swal from 'sweetalert';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  maxWidth: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 3
};

const ModalUpdatePassword = (props) => {
  const [proses, setProses] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [retryNewPassword, setRetryNewPassword] = useState('')
  const [oldPasswordError, setOldPasswordError] = useState(false)
  const [newPasswordError, setNewPasswordError] = useState(false)
  const [retryNewPasswordError, setRetryNewPasswordError] = useState(false)

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRetryPassword, setShowRetryPassword] = useState(false);

  const validationForm = () => {
    let isError = false
    if (!oldPassword || oldPassword.length < 8) {
      setOldPasswordError(true)
      isError = true
    }
    else setOldPasswordError(false)

    if (!newPassword || newPassword.length < 8) {
      setNewPasswordError(true)
      isError = true
    }
    else setNewPasswordError(false)

    if (!retryNewPassword || retryNewPassword.length < 8 || newPassword !== retryNewPassword) {
      setRetryNewPasswordError(true)
      isError = true
    }
    else setRetryNewPasswordError(false)

    return isError
  }

  const submit = async (e) => {
    e.preventDefault();

    setProses(true)
    if (await !validationForm()) {
      try {
        let token = Cookies.get('token_fkub')

        let newInfo = {
          password: oldPassword,
          new_password: newPassword,
          retry_new_password: retryNewPassword,
        }

        await API.put(`/api/v1/user/${props.userProfile._id}/password`, newInfo, { headers: { token: `Bearer ${token}` } })

        swal("Berhasil", "Update password berhasil!", "success");
        props.onClose()
      } catch (err) {
        // console.log(err)
        swal("Error", err.response ? err.response.data.m : 'Please try again!', "error");
      }
    }
    setProses(false)
  }

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ p: '16px 24px', borderBottom: '0.5px solid #aaa', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography id="modal-modal-title" variant="h6" style={{ fontWeight: 'bold' }}>
            Ubah Kata Sandi
          </Typography>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={props.onClose} />
        </Box>
        <Box component="form" noValidate>
          <Box sx={{ p: '32px 24px' }}>
            <FormControl sx={{ width: '100%', mb: '24px' }} variant="outlined" size="small" required error={oldPasswordError}>
              <InputLabel>Kata Sandi Lama</InputLabel>
              <OutlinedInput variant="outlined"
                type={showOldPassword ? "string" : "password"}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                style={{ width: '100%' }}
                disabled={proses}
                label="Kata Sandi Lama"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowOldPassword(!showOldPassword)}
                      edge="end"
                    >
                      {!showOldPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl sx={{ width: '100%', mb: '24px' }} variant="outlined" size="small" required error={newPasswordError}>
              <InputLabel>Kata Sandi Baru</InputLabel>
              <OutlinedInput variant="outlined"
                type={showNewPassword ? "string" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{ width: '100%' }}
                disabled={proses}
                label="Kata Sandi Baru"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      edge="end"
                    >
                      {!showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <FormControl sx={{ width: '100%' }} variant="outlined" size="small" required error={retryNewPasswordError}>
              <InputLabel>Ulangi Kata Sandi Baru</InputLabel>
              <OutlinedInput variant="outlined"
                type={showRetryPassword ? "string" : "password"}
                value={retryNewPassword}
                onChange={(e) => setRetryNewPassword(e.target.value)}
                style={{ width: '100%' }}
                disabled={proses}
                label="Ulangi Kata Sandi Baru"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowRetryPassword(!showRetryPassword)}
                      edge="end"
                    >
                      {!showRetryPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
          <Box sx={{ textAlign: 'right', mb: 2, px: 3 }}>
            <Button sx={{ color: 'black', textTransform: 'none', mr: 3 }} onClick={props.onClose}>Batal</Button>
            <Button type="submit" variant="contained" style={{ backgroundColor: '#9F0102', color: 'white', textTransform: 'none' }} onClick={submit}>Simpan Perubahan</Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalUpdatePassword
